import { TextField, InputAdornment } from "@mui/material"
import SearchIcon from '@mui/icons-material/Search';
import { txt } from "../../services/translation";

export default function Search({value, onChange, label, required, disabled, sx, placeholder}){

    return <TextField
        label={label || txt('search')}
        type='search'
        size='small'
        value={value}
        onChange={onChange}
        InputProps={{
            startAdornment: <InputAdornment position='start'><SearchIcon/></InputAdornment>
        }}
        sx={sx || {}}
        required={required ? true : false}
        disabled={disabled ? true : false}
        placeholder={placeholder || ''}
    />
}